import React, { useState, useCallback, useMemo, useEffect } from 'react'
import {
  Radio,
  Button,
  Input,
  Upload,
  Message,
  Modal
} from '@arco-design/web-react'
import { b2ValueUnit } from 'common/utils'
import {
  IconDelete,
  IconPlus,
  IconUpload,
  IconEye
} from '@arco-design/web-react/icon'
import ColorPicker, { useColorPicker } from 'react-best-gradient-color-picker'
import './SaasSeting.scss'
import { upload } from 'api/apis'
import { BosClient } from '@baiducloud/sdk'
import { updateSaasSetting } from 'api/apis'
import { saasDefaultSetting } from 'mocks/saasDefaultSetting'

const SaasSeting = ({ data, changeSetting }) => {
  const { setting } = data
  const style = setting?.GlobalConfiguration
  const normalizeBoolean = (value) => value === true || value === 'true'
  const currentColorLogo = style?.business_logo || style?.logo || ''
  // 动态列表状态

  // const [scrollList, setScrollList] = useState(setting?.hellodata || [])
  // 表单验证状态

  const [validationErrors, setValidationErrors] = useState({})
  // 颜色状态定义

  const [backgroundColor, setBackgroundColor] = useState(
    style?.css?.['--creationplatform-background'] ||
      'linear-gradient(122deg, #4e3eff 2%, #ececff 83%)'
  ) // 文档创作台背景色

  const [borderColor, setBorderColor] = useState(
    style?.css?.['--yoo-theme-border-color'] || '#4838ff'
  ) // 边线颜色

  const [colorBg, setColorBg] = useState(
    style?.css?.['--yoo-theme-color'] || '#4838ff'
  ) // 默认主题色

  const [hoverColor, setHoverColor] = useState(
    style?.css?.['--yoo-theme-hover-bg'] || '#FFF7FF'
  ) // 按钮hover颜色

  const [lgColor, setLgColor] = useState(
    style?.css?.['--yoo-theme-lg'] ||
      'linear-gradient(270deg, #6040fc 15%, #e750e6 100%)'
  ) // 首页按钮文字颜色

  const [lgimageColor, setLgimageColor] = useState(
    style?.css?.['--yoo-theme-lgimage'] ||
      'linear-gradient(90deg, #FA52E3 0%, #4E3EFF 100%)'
  ) // 流程输入框发送按钮颜色

  const [tolgimageColor, setTolgimageColor] = useState(
    style?.css?.['--yoo-theme-tolgimage'] ||
      'linear-gradient(right, #fa52e3 25%, #4e3eff 50%, #2e91ff 75%, #ff5ef9 100% )'
  ) // 首页输入框发送按钮颜色

  // 上传文件状态
  const [homeColorLogo, setHomeColorLogo] = useState(currentColorLogo) // 首页彩色logo
  const [homeColorLogoFile, setHomeColorLogoFile] = useState(null) // 首页彩色logoFile - 初始化为null

  const [whiteLogo, setWhiteLogo] = useState(style?.white_logo) // 白色logo
  const [whiteLogoFile, setWhiteLogoFile] = useState(null) // 白色logoFile - 初始化为null

  const [homeBackgroundIcon, setHomeBackgroundIcon] = useState(
    style?.home_banner
  ) // 首页背景icon
  const [homeBackgroundIconFile, setHomeBackgroundIconFile] = useState(null) // 首页背景iconFile - 初始化为null

  // 首页文本状态
  const [homeTextLine1, setHomeTextLine1] = useState(
    style?.home_uptitle || '会说话'
  )
  const [homeTextLine2, setHomeTextLine2] = useState(
    style?.home_title || '就能写好PPT'
  )
  const [showLogo, setShowLogo] = useState(
    normalizeBoolean(style?.showlogo ?? style?.show_logo)
  ) // 是否联名展示logo
  const [helloData, setHelloData] = useState(setting?.hellodata || [''])
  const [activeColorIndex, setActiveColorIndex] = useState(-1)
  const [draggingScrollIndex, setDraggingScrollIndex] = useState(-1)
  const [dragOverScrollIndex, setDragOverScrollIndex] = useState(-1)
  // 颜色选择器钩子关联
  useColorPicker(lgColor, setLgColor)
  useColorPicker(lgimageColor, setLgimageColor)
  useColorPicker(tolgimageColor, setTolgimageColor)
  useColorPicker(hoverColor, setHoverColor)
  useColorPicker(borderColor, setBorderColor)
  useColorPicker(colorBg, setColorBg)
  useColorPicker(backgroundColor, setBackgroundColor)

  // 创建一个辅助函数来生成文件对象
  const createFileObject = useCallback((fileInfo) => {
    if (!fileInfo) {
      return null
    }
    if (typeof fileInfo === 'string') {
      return {
        uid: fileInfo,
        name: fileInfo.split('/').pop() || 'uploaded_file',
        url: fileInfo,
        status: 'done',
        percent: 100,
        response: {
          result_url: fileInfo
        }
      }
    }

    return {
      uid: fileInfo.object_key || Date.now().toString(),
      name: fileInfo.file || 'uploaded_file',
      url: fileInfo.result_url || fileInfo.url || fileInfo,
      status: 'done',
      percent: 100,
      response: fileInfo
    }
  }, [])

  const syncPreviewFile = useCallback((url, setter) => {
    setter(url ? createFileObject(url) : null)
  }, [createFileObject])

  useEffect(() => {
    if (setting?.hellodata) {
      setHelloData(setting.hellodata)
    }
    const nextHomeBanner = style?.home_banner || ''
    const nextWhiteLogo = style?.white_logo || ''
    const nextColorLogo = style?.business_logo || style?.logo || ''

    setHomeBackgroundIcon(nextHomeBanner)
    setWhiteLogo(nextWhiteLogo)
    setHomeColorLogo(nextColorLogo)
    syncPreviewFile(nextHomeBanner, setHomeBackgroundIconFile)
    syncPreviewFile(nextWhiteLogo, setWhiteLogoFile)
    syncPreviewFile(nextColorLogo, setHomeColorLogoFile)
    setShowLogo(normalizeBoolean(style?.showlogo ?? style?.show_logo))
    if (style?.home_uptitle) {
      setHomeTextLine1(style.home_uptitle)
    }
    if (style?.home_title) {
      setHomeTextLine2(style.home_title)
    }
    if (style?.css) {
      setBackgroundColor(style.css['--creationplatform-background'] || '')
      setBorderColor(style.css['--yoo-theme-border-color'] || '#4838ff')
      setColorBg(style.css['--yoo-theme-color'] || '#4838ff')
      setHoverColor(style.css['--yoo-theme-hover-bg'] || '#FFF7FF')
      setLgColor(style.css['--yoo-theme-lg'] || '')
      setLgimageColor(style.css['--yoo-theme-lgimage'] || '')
      setTolgimageColor(style.css['--yoo-theme-tolgimage'])
    }
  }, [style?.css, style, setting?.hellodata, syncPreviewFile])

  // 颜色配置数组 - 统一管理所有颜色选项
  const colorConfig = useMemo(() => [
    {
      label: '--creationplatform-background',
      name: '文档创作台背景色',
      value: backgroundColor,
      onChange: setBackgroundColor
    },
    {
      label: '--yoo-theme-border-color',
      name: '边线颜色',
      value: borderColor,
      onChange: setBorderColor
    },
    {
      label: '--yoo-theme-color',
      name: '默认主题色',
      value: colorBg,
      onChange: setColorBg
    },
    {
      label: '--yoo-theme-hover-bg',
      name: '按钮hover颜色',
      value: hoverColor,
      onChange: setHoverColor
    },
    {
      label: '--yoo-theme-lg',
      name: '首页按钮文字颜色',
      value: lgColor,
      onChange: setLgColor
    },
    {
      label: '--yoo-theme-lgimage',
      name: '流程输入框发送按钮颜色',
      value: lgimageColor,
      onChange: setLgimageColor
    },
    {
      label: '--yoo-theme-tolgimage',
      name: '首页输入框发送按钮颜色',
      value: tolgimageColor,
      onChange: setTolgimageColor
    }
  ])

  const isGradientValue = (value = '') =>
    typeof value === 'string' && value.includes('gradient')

  const formatColorValue = (value = '') => {
    if (!value) {
      return '--'
    }
    if (isGradientValue(value)) {
      return 'Linear'
    }
    return value.toUpperCase()
  }
  const activeColorConfig =
    activeColorIndex > -1 ? colorConfig[activeColorIndex] : null

  const handleUpload = (option, setter, fileSetter) => {
    const client = new BosClient({})
    const file = option.file
    const param = {
      type: '',
      mime: option.file.type || 'application/octet-stream',
      size: option.file.size,
      file: option.file.name
    }
    upload(param).then((res) => {
      if (res.code === 200) {
        const bosConfig = {
          endpoint: res.data.end_point,
          credentials: {
            ak: res.data.accessKeyID,
            sk: res.data.secretAccessKey
          },
          sessionToken: res.data.sessionToken
        }
        client.config = bosConfig
        const bucket = res.data.buck_name

        const done = (response) => {
          // 成功回调处理
          setter(res.data.result_url)
          console.log(res.data.result_url)
          // 创建文件对象并设置到fileList状态中
          const fileObject = createFileObject(res.data)
          fileObject.originFile = file // 保留原始文件对象，确保预览始终可用
          fileSetter(fileObject)

          // Message.success(`${file.name} 上传成功`)
        }

        const fail = (fail) => {
          // 失败回调处理
          Message.error(`${file.name} 上传失败`)
          setter(null)
        }
        // 合并headers
        const requestHeaders = {
          ...res.data.headers
        }

        if (
          file.type.indexOf('image') > -1 &&
          !requestHeaders['Content-Type']
        ) {
          requestHeaders['Content-Type'] = file.type
        }

        client
          .putObjectFromBlob(bucket, res.data.object_key, file, requestHeaders)
          .then(done)
          .catch(fail)

        client.on('progress', function (evt) {
          if (evt.lengthComputable) {
            const percentageValue = parseInt(
              (evt.loaded / evt.total) * 100 + ''
            )
            // 进度处理
            console.log(`上传进度: ${percentageValue}%`)
          }
        })
      }
    })
  }
  const renderUploadList1 = (filesList, props) => (
    <div style={{ display: 'flex', marginTop: 12, width: '100%' }}>
      {filesList.map((file) => {
        const url = file.originFile
          ? URL.createObjectURL(file.originFile)
          : file.url
        return (
          <div
            style={{
              width: '100%',
              maxWidth: 140,
              height: 120,
              borderRadius: 10,
              position: 'relative'
            }}
            key={file.uid}
          >
            <div
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                opacity: 0,
                zIndex: 100,
                transition: 'opacity 0.2s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = 1
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = 0
              }}
            >
              <div
                onClick={() => {
                  Modal.info({
                    title: '预览',
                    content: (
                      <img
                        src={url || file.url}
                        width="100%"
                        alt={file.name.split('.')[0]}
                      />
                    )
                  })
                }}
              >
                <IconEye style={{ fontSize: 12, color: '#fff' }} />
              </div>
              <div>
                <IconDelete
                  style={{ fontSize: 12, color: '#fff', marginLeft: 10 }}
                  onClick={() => {
                    props.onRemove(file)
                  }}
                />
              </div>
            </div>
            <img
              src={url}
              style={{ width: '100%', height: '100%', borderRadius: 10 }}
              alt={file.name.split('.')[0]}
            />
          </div>
        )
      })}
    </div>
  )
  const renderUploadList2 =
    (previewBackground = '#f7f8fa') =>
    (filesList, props) => (
      <div style={{ display: 'flex', marginTop: 12, width: '100%' }}>
        {filesList.map((file) => {
          const url = file.originFile
            ? URL.createObjectURL(file.originFile)
            : file.url
          return (
            <div
              style={{
                width: '100%',
                height: 50,
                borderRadius: 10,
                position: 'relative',
                background: previewBackground,
                border: '1px solid #e5e6eb',
                overflow: 'hidden'
              }}
              key={file.uid}
            >
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  borderRadius: 10,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  opacity: 0,
                  zIndex: 100,
                  transition: 'opacity 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.opacity = 1
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.opacity = 0
                }}
              >
                <div
                  onClick={() => {
                    Modal.info({
                      title: '预览',
                      content: (
                        <img
                          src={url || file.url}
                          width="100%"
                          alt={file.name.split('.')[0]}
                        />
                      )
                    })
                  }}
                >
                  <IconEye style={{ fontSize: 12, color: '#fff' }} />
                </div>
                <div>
                  <IconDelete
                    style={{ fontSize: 12, color: '#fff', marginLeft: 10 }}
                    onClick={() => {
                      props.onRemove(file)
                    }}
                  />
                </div>
              </div>
              <img
                src={url}
                style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: 10,
                  objectFit: 'contain',
                  padding: '8px 12px'
                }}
                alt={file.name.split('.')[0]}
              />
            </div>
          )
        })}
      </div>
    )

  // 动态列表操作方法
  const addScrollItem = useCallback(() => {
    if (helloData.length >= 5) {
      Message.error('最多只能添加5条滚动条内容')
      return
    }
    setHelloData([...helloData, ''])
    setValidationErrors({})
  }, [helloData])

  const removeScrollItem = useCallback(
    (index) => {
      // 只剩一条时不允许删除
      if (helloData.length <= 1) {
        Message.warning('至少保留一条滚动文本')
        return
      }
      const newList = [...helloData]
      newList.splice(index, 1)
      setHelloData(newList)
      const newErrors = { ...validationErrors }
      delete newErrors[index]
      setValidationErrors(newErrors)
    },
    [helloData, validationErrors]
  )

  const handleScrollChange = useCallback(
    (index, value) => {
      const newList = [...helloData]
      newList[index] = value
      setHelloData(newList)

      const newErrors = { ...validationErrors }
      if (!value.trim()) {
        newErrors[index] = `第${index + 1}项不能为空`
      } else {
        delete newErrors[index]
      }
      setValidationErrors(newErrors)
    },
    [helloData, validationErrors]
  )

  const handleScrollDragStart = useCallback((index) => {
    setDraggingScrollIndex(index)
    setDragOverScrollIndex(index)
  }, [])

  const handleScrollDragOver = useCallback((event, index) => {
    event.preventDefault()
    if (dragOverScrollIndex !== index) {
      setDragOverScrollIndex(index)
    }
  }, [dragOverScrollIndex])

  const handleScrollDrop = useCallback(
    (index) => {
      if (
        draggingScrollIndex < 0 ||
        index < 0 ||
        draggingScrollIndex === index
      ) {
        setDraggingScrollIndex(-1)
        setDragOverScrollIndex(-1)
        return
      }

      const newList = [...helloData]
      const [movedItem] = newList.splice(draggingScrollIndex, 1)
      newList.splice(index, 0, movedItem)
      setHelloData(newList)
      setValidationErrors({})
      setDraggingScrollIndex(-1)
      setDragOverScrollIndex(-1)
    },
    [draggingScrollIndex, helloData]
  )

  const resetScrollDragState = useCallback(() => {
    setDraggingScrollIndex(-1)
    setDragOverScrollIndex(-1)
  }, [])

  const getScrollListData = useCallback(() => {
    setHelloData(helloData.filter((item) => item.trim()))
    return helloData
  }, [helloData])

  const validateScrollList = useCallback(() => {
    const errors = {}
    let isValid = true

    // helloData?.forEach((item, index) => {
    //   if (!item.trim()) {
    //     errors[index] = `第${index + 1}项不能为空`
    //     isValid = false
    //   } else if (item.length > 50) {
    //     errors[index] = `第${index + 1}项不能超过50个字符`
    //     isValid = false
    //   }
    // })

    setValidationErrors(errors)
    return isValid
  }, [helloData])

  const beforeUpload = (file) => {
    var AllImgExt = '.png|.jpg|.jpeg|.gif|.svg|'
    var extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase() //（把路径中的所有字母全部转换为小写）
    if (AllImgExt.indexOf(extName + '|') === -1) {
      let ErrMsg =
        '该文件类型不允许上传。请上传 .png,.jpg,.jpeg,.gif,.svg类型的文件，当前文件类型为' +
        extName
      Message.error(ErrMsg)
      return false
    }
    const isLt10M = !(
      b2ValueUnit(file.size)[1] === 'B' ||
      b2ValueUnit(file.size)[1] === 'KB' ||
      (b2ValueUnit(file.size)[1] === 'MB' && b2ValueUnit(file.size)[0] <= 5)
    )
    return new Promise((resolve, reject) => {
      if (isLt10M) {
        Message.error('上传文件不能大于5MB')
        reject()
      } else {
        resolve()
      }
    })
  }
  const handleAssetFileChange = useCallback((fileList, fileSetter, valueSetter) => {
    const nextFile = fileList[0] || null
    fileSetter(nextFile)
    if (!nextFile) {
      valueSetter('')
    }
  }, [])
  const setRadioValue = (value) => {
    console.log('setRadioValue', value)
    setShowLogo(value)
  }
  const handleSubmit = useCallback(
    (defaultData) => {
      if (validateScrollList()) {
        // 收集所有组件信息
        const formData = {
          setting: {
            ...setting,
            hellodata: getScrollListData(),
            GlobalConfiguration: {
              ...setting.GlobalConfiguration,
              business_logo: homeColorLogo,
              white_logo: whiteLogo,
              home_banner: homeBackgroundIcon,
              showlogo: showLogo, // 从Radio组件获取的值
              home_uptitle: homeTextLine1,
              home_title: homeTextLine2,
              css: colorConfig.reduce((obj, item) => {
                obj[item.label] = item.value
                return obj
              }, {})
            }
          },
          app_id: data?.project_app?.app_id || ''
        }
        if (defaultData) {
          formData.setting = defaultData
          window.location.reload()
        }
        updateSaasSetting(formData).then((res) => {
          if (res.code === 200) {
            Message.success('更新成功')
            setTimeout(() => {
              // 向 iframe 子页面发送刷新指令
              const iframe = document.querySelector('iframe')
              if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage({ type: 'refresh' }, '*')
              }
            }, 800)
          } else {
            Message.error(res.msg || '更新失败')
          }
        })
      }
    },
    [
      validateScrollList,
      homeColorLogo,
      whiteLogo,
      homeBackgroundIcon,
      homeTextLine1,
      homeTextLine2,
      colorConfig,
      showLogo,
      setting,
      getScrollListData,
      data
    ]
  )

  return (
    <div className="sass-setting-set">
      {/* <div className="sass-setting-info-title">风格配置</div> */}

      {/* 上传区域 */}
      <div className="style-setting-section style-setting-upload-section">
        <div className="style-setting-section-header">
          <div className="style-setting-section-title">品牌素材配置</div>
          <div className="style-setting-section-desc">
            配置首页展示所需的 logo、联名策略和背景素材
          </div>
        </div>

        <div className="style-setting-upload-grid">
          <div className="style-setting-upload-card">
            <div className="style-setting-upload-card-title">首页彩色 logo</div>
            <div className="style-setting-upload-card-desc">
              SVG 格式，建议尺寸 150 x 50
            </div>
            <Upload
              renderUploadList={renderUploadList2('#f7f8fa')}
              accept={'.png,.jpg,.jpeg,.gif,.svg'}
              fileList={homeColorLogoFile ? [homeColorLogoFile] : []}
              limit={1}
              onChange={(fileList) =>
                handleAssetFileChange(
                  fileList,
                  setHomeColorLogoFile,
                  setHomeColorLogo
                )
              }
              customRequest={(option) => {
                handleUpload(option, setHomeColorLogo, setHomeColorLogoFile)
              }}
              beforeUpload={beforeUpload}
            >
              <div className="style-setting-upFile-box">
                <IconPlus style={{ fontSize: 20, color: '#A6A6A6' }} />
              </div>
            </Upload>
          </div>

          <div className="style-setting-upload-card">
            <div className="style-setting-upload-card-title">白色 logo</div>
            <div className="style-setting-upload-card-desc">
              SVG 格式，建议尺寸 200 x 50
            </div>
            <Upload
              renderUploadList={renderUploadList2('#f7f8fa')}
              accept={'.png,.jpg,.jpeg,.gif,.svg'}
              fileList={whiteLogoFile ? [whiteLogoFile] : []}
              limit={1}
              onChange={(fileList) =>
                handleAssetFileChange(fileList, setWhiteLogoFile, setWhiteLogo)
              }
              customRequest={(option) => {
                handleUpload(option, setWhiteLogo, setWhiteLogoFile)
              }}
              className="up-icon"
              beforeUpload={beforeUpload}
            >
              <div className="style-setting-upFile-box">
                <IconPlus style={{ fontSize: 20, color: '#A6A6A6' }} />
              </div>
            </Upload>
          </div>
        </div>

        <div className="style-setting-inline-field">
          <div>
            <div className="style-setting-inline-field-label">是否联名展示 logo</div>
            <div className="style-setting-inline-field-desc">
              控制首页是否同时展示联名品牌标识
            </div>
          </div>
          <Radio.Group
            className="style-setting-radio style-setting-inline-radio"
            value={showLogo}
            onChange={setRadioValue}
          >
            <Radio value={true}>是</Radio>
            <Radio value={false}>否</Radio>
          </Radio.Group>
        </div>

        <div className="style-setting-upload-card style-setting-upload-card-large">
          <div className="style-setting-upload-card-title">首页背景 icon</div>
          <div className="style-setting-upload-card-desc">
            支持 JPG、JPEG、PNG、GIF、SVG 格式，建议尺寸 480 x 480
          </div>
          <Upload
            renderUploadList={renderUploadList1}
            accept={'.png,.jpg,.jpeg,.gif,.svg'}
            fileList={homeBackgroundIconFile ? [homeBackgroundIconFile] : []}
            limit={1}
              onChange={(fileList) =>
                handleAssetFileChange(
                  fileList,
                  setHomeBackgroundIconFile,
                  setHomeBackgroundIcon
                )
              }
            customRequest={(option) => {
              handleUpload(option, setHomeBackgroundIcon, setHomeBackgroundIconFile)
            }}
            className="home-icon"
            beforeUpload={beforeUpload}
          >
            <div className="style-setting-upFile-icon">
              <IconPlus style={{ fontSize: 20, color: '#A6A6A6' }} />
            </div>
          </Upload>
        </div>
      </div>

      {/* 首页文本配置 */}
      <div className="style-setting-section style-setting-text-section">
        <div className="style-setting-section-header">
          <div className="style-setting-section-title">首页大文本</div>
          <div className="style-setting-section-desc">
            控制首页主视觉标题的两行文案展示
          </div>
        </div>
        <div className="style-setting-text-field">
          <div className="style-setting-text-label-wrap">
            <div className="style-setting-text-label">第一行</div>
            <div className="style-setting-text-desc">适合作为短句引导</div>
          </div>
          <Input
            className="custom-input-set style-setting-text-input"
            value={homeTextLine1}
            onChange={(e) => setHomeTextLine1(e.target?.value || e)}
            placeholder="请输入第一行文本"
          />
        </div>
        <div className="style-setting-text-field">
          <div className="style-setting-text-label-wrap">
            <div className="style-setting-text-label">第二行</div>
            <div className="style-setting-text-desc">作为主标题强调</div>
          </div>
          <Input
            className="custom-input-set style-setting-text-input"
            value={homeTextLine2}
            onChange={(e) => setHomeTextLine2(e.target?.value || e)}
            placeholder="请输入第二行文本"
          />
        </div>
      </div>

      {/* 滚动文本配置 */}
      <div className="style-setting-section">
        <div className="style-setting-section-header">
          <div className="style-setting-section-title">对话框上方滚动文本</div>
          <div className="style-setting-section-desc">
            最多添加 5 条提示语，提升首屏输入引导感
          </div>
        </div>
        {helloData?.map((item, idx) => (
          <div
            key={idx}
            className={`scroll-text-card ${
              validationErrors[idx] ? 'scroll-text-card-error-state' : ''
            } ${
              dragOverScrollIndex === idx && draggingScrollIndex !== idx
                ? 'scroll-text-card-drag-over'
                : ''
            }`}
            onDragOver={(event) => handleScrollDragOver(event, idx)}
            onDrop={() => handleScrollDrop(idx)}
          >
            <div className="scroll-text-card-main">
              <div
                className={`scroll-text-card-anchor ${
                  draggingScrollIndex === idx ? 'is-dragging' : ''
                }`}
                draggable
                onDragStart={() => handleScrollDragStart(idx)}
                onDragEnd={resetScrollDragState}
              >
                <span className="scroll-text-card-anchor-grip">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </div>
              <Input
                className="custom-input-set scroll-text-card-input"
                value={item}
                onChange={(e) =>
                  handleScrollChange(
                    idx,
                    typeof e === 'string' ? e : e.target?.value || e
                  )
                }
                placeholder={`请输入第 ${idx + 1} 条滚动文本`}
              />
              <button
                type="button"
                className="scroll-text-card-delete"
                onClick={() => removeScrollItem(idx)}
              >
                <IconDelete />
              </button>
            </div>
            {validationErrors[idx] && (
              <span className="scroll-text-card-error">
                {validationErrors[idx]}
              </span>
            )}
          </div>
        ))}
        {helloData.length < 5 && (
          <Button className="scroll-text-add-btn" type="outline" onClick={addScrollItem}>
            <IconPlus />
            添加文本
          </Button>
        )}
      </div>

      {/* 主题颜色配置 - 遍历渲染 */}
      <div className="style-setting-section">
        <div className="style-setting-section-header">
          <div className="style-setting-section-title">主题颜色配置</div>
          <div className="style-setting-section-desc">
            统一调整品牌主色、渐变和按钮反馈色
          </div>
        </div>
        {colorConfig.map((config, index) => (
          <div key={index} className="color-config-row">
            <div className="color-config-label">{config.name}</div>
            <button
              type="button"
              className="style-setting-color-trigger"
              onClick={() => setActiveColorIndex(index)}
            >
              <span className="style-setting-color-content">
                <span
                  className={`style-setting-color-preview ${
                    isGradientValue(config.value) ? 'is-gradient' : ''
                  }`}
                  style={{ background: config.value }}
                ></span>
                <span className="style-setting-color-value">
                  {formatColorValue(config.value)}
                </span>
              </span>
              <span className="style-setting-color-arrow"></span>
            </button>
          </div>
        ))}
      </div>

      <Modal
        className="style-setting-color-modal"
        title={activeColorConfig?.name || '主题颜色配置'}
        visible={activeColorIndex > -1}
        footer={null}
        onCancel={() => setActiveColorIndex(-1)}
      >
        {activeColorConfig ? (
          <div className="style-setting-color-modal-body">
            <ColorPicker
              value={activeColorConfig.value}
              onChange={activeColorConfig.onChange}
            />
          </div>
        ) : null}
      </Modal>

      <div className="saas-setting-footer">
        <Button
          type="text"
          className="saas-setting-footer-reset"
          onClick={() => handleSubmit(saasDefaultSetting)}
        >
          恢复默认
        </Button>
        <Button
          type="primary"
          className="saas-setting-footer-submit"
          onClick={() => handleSubmit()}
        >
          确认保存
        </Button>
      </div>
    </div>
  )
}

export default SaasSeting
